(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const header = document.querySelector('[data-search-endpoint]');
    if (!header) return;

    const root = header.closest('.shopify-section') || document;
    const searchEndpoint = header.dataset.searchEndpoint;
    const cartEndpoint = header.dataset.cartEndpoint;
    const cartAddEndpoint = header.dataset.cartAddEndpoint;
    const currencyCode = header.dataset.currency || 'GBP';
    const cartCountNodes = root.querySelectorAll('[data-cart-count]');
    const searchInstances = Array.from(root.querySelectorAll('[data-predictive-search]'));
    const searchControllers = new WeakMap();
    const searchTimeouts = new WeakMap();

    const formatMoney = (value) => {
      if (typeof value !== 'number') return '';
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currencyCode
      }).format(value / 100);
    };

    const escapeHtml = (value) => {
      const div = document.createElement('div');
      div.textContent = value || '';
      return div.innerHTML;
    };

    const extractImage = (product) => {
      if (product && product.featured_image && product.featured_image.url) return product.featured_image.url;
      if (product && product.image) return product.image;
      return '';
    };

    const extractPrice = (product) => {
      if (!product) return '';
      if (typeof product.price === 'number') return formatMoney(product.price);
      if (product.price && typeof product.price.amount === 'number') return formatMoney(product.price.amount);
      return '';
    };

    const clearPredictiveResults = (instance) => {
      const controller = searchControllers.get(instance);
      const wrapper = instance.querySelector('[data-predictive-results-wrapper]');
      const results = instance.querySelector('[data-predictive-results]');
      const status = instance.querySelector('[data-predictive-status]');
      const input = instance.querySelector('[data-predictive-input]');
      if (controller) controller.abort();
      if (results) results.innerHTML = '';
      if (wrapper) wrapper.hidden = true;
      if (status) status.textContent = '';
      if (input) input.setAttribute('aria-expanded', 'false');
    };

    const renderPredictiveResults = (instance, products, query) => {
      const wrapper = instance.querySelector('[data-predictive-results-wrapper]');
      const results = instance.querySelector('[data-predictive-results]');
      const status = instance.querySelector('[data-predictive-status]');
      const searchAll = instance.querySelector('[data-search-all]');
      const input = instance.querySelector('[data-predictive-input]');

      if (!wrapper || !results || !status || !searchAll || !input) return;

      searchAll.href = '/search?q=' + encodeURIComponent(query);

      if (!products.length) {
        results.innerHTML = '<li class="p11-site-header__predictive-meta">No products found for "' + escapeHtml(query) + '".</li>';
        status.textContent = 'No predictive search results available.';
        wrapper.hidden = false;
        input.setAttribute('aria-expanded', 'true');
        return;
      }

      results.innerHTML = products.map((product, index) => {
        const image = extractImage(product);
        const title = escapeHtml(product.title);
        const url = escapeHtml(product.url);
        const vendor = product.vendor ? '<span class="p11-site-header__predictive-meta">' + escapeHtml(product.vendor) + '</span>' : '';
        const price = extractPrice(product);
        const priceMarkup = price ? '<span class="p11-site-header__predictive-price">' + escapeHtml(price) + '</span>' : '';
        const imageMarkup = image
          ? '<img class="p11-site-header__predictive-image" src="' + escapeHtml(image) + '" alt="" loading="lazy" width="72" height="72">'
          : '<span class="p11-site-header__predictive-image" aria-hidden="true"></span>';

        return '<li role="option" aria-selected="false" id="PredictiveResult-' + index + '"><a class="p11-site-header__predictive-result" href="' + url + '">' + imageMarkup + '<span class="p11-site-header__predictive-copy"><span class="p11-site-header__predictive-title">' + title + '</span>' + vendor + priceMarkup + '</span></a></li>';
      }).join('');

      status.textContent = products.length + ' predictive search results available.';
      wrapper.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    };

    const fetchPredictiveResults = (instance, query) => {
      if (!query || !searchEndpoint) {
        clearPredictiveResults(instance);
        return;
      }

      const controller = new AbortController();
      const previousController = searchControllers.get(instance);
      if (previousController) previousController.abort();
      searchControllers.set(instance, controller);

      const url = new URL(searchEndpoint, window.location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '5');
      url.searchParams.set('resources[options][unavailable_products]', 'hide');

      fetch(url.toString(), {
        signal: controller.signal,
        headers: {
          Accept: 'application/json'
        }
      })
        .then((response) => response.ok ? response.json() : null)
        .then((data) => {
          if (!data) return;
          const products = data.resources && data.resources.results && data.resources.results.products ? data.resources.results.products : [];
          renderPredictiveResults(instance, products, query);
        })
        .catch((error) => {
          if (error && error.name === 'AbortError') return;
          clearPredictiveResults(instance);
        });
    };

    const updateCartCount = () => {
      if (!cartEndpoint) return;
      fetch(cartEndpoint, {
        headers: {
          Accept: 'application/json'
        }
      })
        .then((response) => response.ok ? response.json() : null)
        .then((cart) => {
          if (!cart) return;
          cartCountNodes.forEach((node) => {
            node.textContent = cart.item_count;
            node.hidden = cart.item_count === 0;
          });
        })
        .catch(() => {});
    };

    const isCartMutation = (url) => {
      if (!url || typeof url !== 'string') return false;
      return url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update') || url.includes('/cart/clear');
    };

    if (!window.__p11HeaderFetchPatched) {
      const nativeFetch = window.fetch.bind(window);
      window.fetch = (...args) => {
        const requestUrl = typeof args[0] === 'string' ? args[0] : args[0] && args[0].url ? args[0].url : '';
        return nativeFetch(...args).then((response) => {
          if (isCartMutation(requestUrl)) {
            document.dispatchEvent(new CustomEvent('p11:cart-refresh'));
          }
          return response;
        });
      };
      window.__p11HeaderFetchPatched = true;
    }

    searchInstances.forEach((instance) => {
      const input = instance.querySelector('[data-predictive-input]');
      if (!input) return;

      input.addEventListener('input', () => {
        const existingTimeout = searchTimeouts.get(instance);
        window.clearTimeout(existingTimeout);
        const query = input.value.trim();
        if (!query) {
          clearPredictiveResults(instance);
          return;
        }
        const timeout = window.setTimeout(() => {
          fetchPredictiveResults(instance, query);
        }, 180);
        searchTimeouts.set(instance, timeout);
      });

      input.addEventListener('focus', () => {
        const query = input.value.trim();
        if (query) fetchPredictiveResults(instance, query);
      });

      input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          clearPredictiveResults(instance);
          input.blur();
        }
      });
    });

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Node)) return;
      searchInstances.forEach((instance) => {
        if (!instance.contains(event.target)) {
          clearPredictiveResults(instance);
        }
      });
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      const action = form.getAttribute('action') || '';
      if (cartAddEndpoint && action.includes(cartAddEndpoint)) {
        window.setTimeout(updateCartCount, 800);
      }
    });

    document.addEventListener('p11:cart-refresh', updateCartCount);
    updateCartCount();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (() => {
    const section = document.currentScript.closest('.p11-collection');
    if (!section) return;

    const sort = section.querySelector('[data-collection-sort]');
    if (sort) {
      sort.addEventListener('change', () => sort.form.submit());
    }

    section.addEventListener('submit', async (event) => {
      const form = event.target.closest('[data-quick-add]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('button');
      if (button) {
        button.disabled = true;
        button.textContent = 'Adding…';
      }
      let resolveCartEvent;
      const cartEventPromise = new Promise((resolve) => {
        resolveCartEvent = resolve;
      });
      const merchandiseId = form.querySelector('[name="id"]')?.value;
      const cartLinesEvent = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
      Object.assign(cartLinesEvent, {
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId, quantity: 1 }],
        promise: cartEventPromise
      });
      form.dispatchEvent(cartLinesEvent);
      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('Unable to add item');
        const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((cartResponse) => cartResponse.json());
        resolveCartEvent({ cart });
        document.dispatchEvent(new CustomEvent('p11:cart-refresh'));
        document.dispatchEvent(new CustomEvent('p11:cart-open'));
        if (button) button.textContent = 'Added';
      } catch (error) {
        resolveCartEvent({ cart: null, userErrors: [{ message: 'Unable to add item' }] });
        form.submit();
      } finally {
        window.setTimeout(() => {
          if (!button) return;
          button.disabled = false;
          button.textContent = 'Quick add';
        }, 1200);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  (() => {
    const root = document.currentScript.closest('.shopify-section');
    if (!root) return;

    const section = root.querySelector('[data-product-section]');
    if (!section) return;

    const currencyCode = section.dataset.currency || 'GBP';
    const addUrl = section.dataset.cartAddUrl;
    const productUrl = section.dataset.productUrl;
    const variantDataNode = section.querySelector('[data-variant-json]');
    const form = section.querySelector('[data-p11-product-form]');
    const idInput = section.querySelector('[data-variant-id-input]');
    const priceCurrent = section.querySelector('[data-price-current]');
    const priceCompare = section.querySelector('[data-price-compare]');
    const priceCaption = section.querySelector('[data-price-caption]');
    const statusNode = section.querySelector('[data-product-status]');
    const addButton = section.querySelector('[data-add-to-cart]');
    const addButtonLabel = section.querySelector('[data-add-to-cart-label]');
    const scentQuizFallback = section.querySelector('[data-scent-quiz-fallback]');
    const optionInputs = Array.from(section.querySelectorAll('.p11-product__option-input'));
    const mediaCards = Array.from(section.querySelectorAll('[data-media-id]'));
    const tabButtons = Array.from(section.querySelectorAll('[data-tab-trigger]'));
    const tabPanels = Array.from(section.querySelectorAll('[data-tab-panel]'));
    const stickyBar = section.querySelector('[data-mobile-sticky-bar]');
    const stickyBarButton = section.querySelector('[data-mobile-sticky-submit]');
    const stickyBarLabel = section.querySelector('[data-mobile-sticky-label]');
    const stickyBarPrice = section.querySelector('[data-mobile-sticky-price]');
    const stickyBarImage = section.querySelector('.p11-product__mobile-sticky-image');
    const purchaseAnchor = section.querySelector('[data-purchase-anchor]');
    const mobileQuery = window.matchMedia('(max-width: 989px)');

    let variants = [];
    let activeVariant = null;
    let purchaseObserver = null;

    if (variantDataNode) {
      try {
        variants = JSON.parse(variantDataNode.textContent);
      } catch (error) {
        variants = [];
      }
    }

    const formatMoney = (value) => {
      if (typeof value !== 'number') return '';
      return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: currencyCode
      }).format(value / 100);
    };

    const getSelectedOptions = () => {
      const fieldsets = Array.from(section.querySelectorAll('.p11-product__option-group'));
      return fieldsets.map((fieldset) => {
        const checked = fieldset.querySelector('.p11-product__option-input:checked');
        return checked ? checked.value : '';
      });
    };

    const findVariant = () => {
      if (!variants.length) return null;
      const selected = getSelectedOptions();
      return variants.find((variant) => {
        if (!variant.options || variant.options.length !== selected.length) return false;
        return variant.options.every((option, index) => option === selected[index]);
      }) || variants[0];
    };

    const updateOptionPills = () => {
      const pills = Array.from(section.querySelectorAll('.p11-product__option-pill'));
      pills.forEach((pill) => {
        const input = pill.querySelector('.p11-product__option-input');
        pill.classList.toggle('is-selected', input ? input.checked : false);
      });
    };

    const updateMediaState = (variant) => {
      if (!variant || !variant.featured_media_id || !mediaCards.length) return;
      mediaCards.forEach((card) => {
        const isMatch = String(card.dataset.mediaId) === String(variant.featured_media_id);
        card.classList.toggle('is-active', isMatch);
      });
      if (stickyBarImage && variant.featured_media_url) {
        stickyBarImage.src = variant.featured_media_url;
      }
    };

    const updatePriceState = (variant) => {
      if (!variant || !priceCurrent || !priceCompare || !priceCaption) return;
      const currentPrice = formatMoney(variant.price);
      priceCurrent.textContent = currentPrice;
      if (stickyBarPrice) stickyBarPrice.textContent = currentPrice;
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        priceCompare.textContent = formatMoney(variant.compare_at_price);
        priceCompare.classList.remove('is-hidden');
        priceCaption.textContent = 'Save ' + formatMoney(variant.compare_at_price - variant.price);
      } else {
        priceCompare.textContent = '';
        priceCompare.classList.add('is-hidden');
        priceCaption.textContent = 'Authentic stock with secure checkout';
      }
    };

    const updateAvailabilityState = (variant) => {
      if (!variant || !addButton || !addButtonLabel || !statusNode || !idInput) return;
      idInput.value = variant.id;
      if (variant.available) {
        addButton.disabled = false;
        addButtonLabel.textContent = 'Add to Bag';
        statusNode.textContent = 'Ready to dispatch';
        if (stickyBarButton) stickyBarButton.disabled = false;
        if (stickyBarLabel) stickyBarLabel.textContent = 'Add to Bag';
        if (scentQuizFallback) scentQuizFallback.classList.add('is-hidden');
      } else {
        addButton.disabled = true;
        addButtonLabel.textContent = 'Sold out';
        statusNode.textContent = 'This variant is currently unavailable';
        if (stickyBarButton) stickyBarButton.disabled = true;
        if (stickyBarLabel) stickyBarLabel.textContent = 'Sold out';
        if (scentQuizFallback) scentQuizFallback.classList.remove('is-hidden');
      }
    };

    const syncVariant = () => {
      activeVariant = findVariant();
      if (!activeVariant) return;
      updateOptionPills();
      updatePriceState(activeVariant);
      updateAvailabilityState(activeVariant);
      updateMediaState(activeVariant);
      if (activeVariant.url) {
        const nextUrl = activeVariant.url.indexOf('http') === 0 ? activeVariant.url : productUrl + '?variant=' + activeVariant.id;
        window.history.replaceState({}, '', nextUrl);
      }
    };

    const handleAddToCart = (event) => {
      event.preventDefault();
      if (!form || !activeVariant || !addUrl) return;

      addButton.disabled = true;
      addButtonLabel.textContent = 'Adding...';
      if (stickyBarButton) stickyBarButton.disabled = true;
      if (stickyBarLabel) stickyBarLabel.textContent = 'Adding...';

      const formData = new FormData(form);
      let resolveCartEvent;
      const cartEventPromise = new Promise((resolve) => {
        resolveCartEvent = resolve;
      });
      const cartLinesEvent = new CustomEvent('shopify:cart:lines-update', { bubbles: true });
      Object.assign(cartLinesEvent, {
        action: 'add',
        context: 'product',
        lines: [{ merchandiseId: activeVariant.id, quantity: 1 }],
        promise: cartEventPromise
      });
      form.dispatchEvent(cartLinesEvent);

      fetch(addUrl + '.js', {
        method: 'POST',
        headers: {
          Accept: 'application/json'
        },
        body: formData
      })
        .then((response) => response.ok ? response.json() : response.json().then((error) => Promise.reject(error)))
        .then(async () => {
          const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((response) => response.json());
          resolveCartEvent({ cart });
          statusNode.textContent = 'Added to bag';
          document.dispatchEvent(new CustomEvent('p11:cart-open'));
          window.setTimeout(() => {
            updateAvailabilityState(activeVariant);
          }, 600);
        })
        .catch((error) => {
          resolveCartEvent({ cart: null, userErrors: [{ message: error && error.description ? error.description : 'Unable to add this item right now' }] });
          const message = error && error.description ? error.description : 'Unable to add this item right now';
          statusNode.textContent = message;
          updateAvailabilityState(activeVariant);
        });
    };

    const activateTab = (key) => {
      tabButtons.forEach((button) => {
        const isActive = button.dataset.tabTrigger === key;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-selected', isActive ? 'true' : 'false');
        button.tabIndex = isActive ? 0 : -1;
      });

      tabPanels.forEach((panel) => {
        const isActive = panel.dataset.tabPanel === key;
        panel.hidden = !isActive;
      });
    };

    const updateStickyVisibility = (isVisible) => {
      if (!stickyBar) return;
      const shouldShow = mobileQuery.matches && !isVisible;
      stickyBar.hidden = !shouldShow;
    };

    const bindStickyObserver = () => {
      if (!stickyBar || !purchaseAnchor) return;
      if (purchaseObserver) purchaseObserver.disconnect();
      purchaseObserver = new IntersectionObserver((entries) => {
        const entry = entries[0];
        updateStickyVisibility(entry ? entry.isIntersecting : true);
      }, {
        threshold: 0.2
      });
      purchaseObserver.observe(purchaseAnchor);
    };

    optionInputs.forEach((input) => {
      input.addEventListener('change', syncVariant);
    });

    if (form) {
      form.addEventListener('submit', handleAddToCart);
    }

    if (stickyBarButton && form) {
      stickyBarButton.addEventListener('click', (event) => {
        handleAddToCart(event);
      });
    }

    tabButtons.forEach((button) => {
      button.addEventListener('click', () => activateTab(button.dataset.tabTrigger));
      button.addEventListener('keydown', (event) => {
        const index = tabButtons.indexOf(button);
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          const next = tabButtons[(index + 1) % tabButtons.length];
          next.focus();
          activateTab(next.dataset.tabTrigger);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          const previous = tabButtons[(index - 1 + tabButtons.length) % tabButtons.length];
          previous.focus();
          activateTab(previous.dataset.tabTrigger);
        }
        if (event.key === 'Home') {
          event.preventDefault();
          tabButtons[0].focus();
          activateTab(tabButtons[0].dataset.tabTrigger);
        }
        if (event.key === 'End') {
          event.preventDefault();
          tabButtons[tabButtons.length - 1].focus();
          activateTab(tabButtons[tabButtons.length - 1].dataset.tabTrigger);
        }
      });
    });

    mobileQuery.addEventListener('change', () => {
      if (!mobileQuery.matches && stickyBar) {
        stickyBar.hidden = true;
      }
    });

    bindStickyObserver();
    syncVariant();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-scent-finder"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initScentFinder = (container) => {
      if (!container || container.dataset.scentFinderReady === 'true') return;

      const root = container.closest('.shopify-section') || container;
      const form = container.querySelector('[data-scent-finder-form]');
      if (!form) return;

      container.dataset.scentFinderReady = 'true';

      const stepMarkers = Array.from(container.querySelectorAll('[data-step-marker]'));
      const stepPanels = Array.from(container.querySelectorAll('[data-step-panel]'));
      const nextButton = container.querySelector('[data-step-next]');
      const backButton = container.querySelector('[data-step-back]');
      const submitButton = container.querySelector('[data-step-submit]');
      const restartButton = container.querySelector('[data-scent-restart]');
      const placeholder = container.querySelector('[data-result-placeholder]');
      const resultCard = container.querySelector('[data-result-card]');
      const resultTag = container.querySelector('[data-result-tag]');
      const resultHeading = container.querySelector('[data-result-heading]');
      const resultSummary = container.querySelector('[data-result-summary]');
      const resultLinks = container.querySelector('[data-result-links]');
      const profiles = Array.from(container.querySelectorAll('[data-profile]'));
      let currentStep = 1;

      const setStep = (step) => {
        currentStep = step;
        stepMarkers.forEach((marker) => {
          marker.classList.toggle('is-active', Number(marker.dataset.stepMarker) === step);
        });
        stepPanels.forEach((panel) => {
          panel.classList.toggle('is-active', Number(panel.dataset.stepPanel) === step);
        });
        if (backButton) backButton.hidden = step === 1;
        if (nextButton) nextButton.hidden = step === stepPanels.length;
        if (submitButton) submitButton.hidden = step !== stepPanels.length;
      };

      const getChoice = (name) => {
        const checked = form.querySelector(`input[name="${name}"]:checked`);
        return checked ? checked.value : '';
      };

      const chooseProfile = () => {
        const family = getChoice('scent_family');
        const wear = getChoice('wear_style');

        if (family === 'intense') return 'intense';
        if (family === 'sweet') return wear === 'light' ? 'floral' : 'sweet';
        if (family === 'floral') return wear === 'bold' ? 'sweet' : 'floral';
        if (family === 'fresh') return wear === 'bold' ? 'intense' : 'fresh';
        return 'fresh';
      };

      const buildSummary = (profile) => {
        const shoppingFor = getChoice('shopping_for');
        const family = getChoice('scent_family');
        const wear = getChoice('wear_style');
        const target = shoppingFor === 'gift' ? 'gift-worthy' : shoppingFor === 'signature' ? 'signature' : 'personal';
        const familyLabel = family === 'fresh' ? 'clean and fresh' : family === 'floral' ? 'soft floral' : family === 'sweet' ? 'warm sweet' : 'bold intense';
        const wearLabel = wear === 'light' ? 'easy everyday wear' : wear === 'balanced' ? 'day-to-night versatility' : 'stronger evening projection';
        return `${profile.dataset.profileSummary} This route fits a ${target} choice, leans ${familyLabel}, and is better suited to ${wearLabel}.`;
      };

      const renderResult = () => {
        const key = chooseProfile();
        const profile = profiles.find((item) => item.dataset.profileKey === key) || profiles[0];
        if (!profile || !resultTag || !resultHeading || !resultSummary || !resultLinks || !placeholder || !resultCard) return;

        resultTag.textContent = profile.dataset.profileTag || 'Recommended edit';
        resultHeading.textContent = profile.dataset.profileHeading || 'Your best next collection';
        resultSummary.textContent = buildSummary(profile);
        resultLinks.innerHTML = '';

        [
          { url: profile.dataset.primaryUrl, label: profile.dataset.primaryLabel },
          { url: profile.dataset.secondaryUrl, label: profile.dataset.secondaryLabel },
          { url: profile.dataset.tertiaryUrl, label: profile.dataset.tertiaryLabel }
        ].forEach((link) => {
          if (!link.url || !link.label) return;
          const anchor = document.createElement('a');
          anchor.className = 'p11-scent-finder__result-link';
          anchor.href = link.url;
          anchor.textContent = link.label;
          resultLinks.appendChild(anchor);
        });

        placeholder.hidden = true;
        resultCard.hidden = false;
      };

      nextButton?.addEventListener('click', () => {
        if (currentStep < stepPanels.length) setStep(currentStep + 1);
      });

      backButton?.addEventListener('click', () => {
        if (currentStep > 1) setStep(currentStep - 1);
      });

      form.addEventListener('submit', (event) => {
        event.preventDefault();
        renderResult();
      });

      restartButton?.addEventListener('click', () => {
        form.reset();
        if (placeholder) placeholder.hidden = false;
        if (resultCard) resultCard.hidden = true;
        setStep(1);
      });

      setStep(1);
    };

    const initAllScentFinders = (scope = document) => {
      const containers = scope.querySelectorAll('[data-scent-finder]');
      containers.forEach((container) => initScentFinder(container));
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initAllScentFinders(), { once: true });
    } else {
      initAllScentFinders();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initAllScentFinders(event.target || document);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
